import React, { useState, useEffect } from 'react';
import './BlogFeaturedTopic.scss';
import { renderCards } from '../../UI/Card/util/renderCards';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';
import { BREAKPOINTS } from '../../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

/**
 * Renders the featured topic block
 * @param {boolean} isFiltering - determines whether the component should display itself
 * @param {boolean} viewAll - Show/hide view all
 * @param {string} image - the image src
 * @param {string} topic - the chosen topic
 * @param {array} recentTagPosts - the two most recent posts
 * @param {string} viewAllLink - link to the listing with all posts
 * @param {boolean} isDarkImage - controls whether the text over image is dark/light
 * @param {boolean} isHomepage
 * @param {boolean} isPressPreview
 */
const BlogFeaturedTopic = ({
  isFiltering = false,
  viewAll,
  image,
  topic,
  recentTagPosts,
  viewAllLink,
  isDarkImage,
  isHomepage = false,
  isPressPreview = false,
}) => {
  const [isDesktop, setIsDesktop] = useState(null);

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
  };

  const renderViewAll = () => {
    if (viewAll) {
      if (!isHomepage) {
        return (
          <div className="c-blog-featured-topic__view-all cta text-cta color-black">
            <a className="color-black" href={viewAllLink}>
              <span>+ View All</span>
            </a>
          </div>
        );
      }
    }
  };

  return !isFiltering ? (
    <div className={`c-blog-featured-topic background-color-${isPressPreview ? 'white' : 'gray'}`}>
      <div className="c-blog-featured-topic__inner">
        <div className="c-blog-featured-topic__content">
          {isHomepage ? (
            <div className="c-blog-featured-topic__image-card-container">
              <div
                className="c-blog-featured-topic__image-card"
                style={{ backgroundImage: `url(${image})` }}
              >
                <div
                  className={`c-blog-featured-topic__title h4-right-grotesk ${
                    isDarkImage ? 'color-white' : 'color-black'
                  }`}
                >
                  <h4>{topic}</h4>
                </div>
              </div>
              {isDesktop && (
                <CTAButton
                  type={'secondary'}
                  link={viewAllLink}
                  text={'View All Articles'}
                  target={'_self'}
                  additionalClasses={'color-black cta'}
                />
              )}
            </div>
          ) : (
            <div
              className="c-blog-featured-topic__image-card"
              style={{ backgroundImage: `url(${image})` }}
            >
              <div
                className={`c-blog-featured-topic__title h4-right-grotesk ${
                  isDarkImage ? 'color-white' : 'color-black'
                }`}
              >
                <h4>{topic}</h4>
              </div>
            </div>
          )}
          {renderCards(recentTagPosts)}
        </div>
      </div>
      {isHomepage && !isDesktop && (
        <CTAButton
          type={'secondary'}
          link={viewAllLink}
          text={'View All Articles'}
          target={'_self'}
          additionalClasses={'color-black cta'}
        />
      )}
      {renderViewAll()}
    </div>
  ) : null;
};

export default BlogFeaturedTopic;
